@if (showSpinnerIfNecessary && (!project && !errorLoadingProject || ssrProjectLoad)) {
  <mat-spinner color="secondary" />
}

@if (!ssrProjectLoad && errorLoadingProject) {
  <div class="error-loading-project">
    <h3>Error Loading</h3>
    <p>
      There was an error loading your order item.
      Please refresh the page to try again.
    </p>
  </div>
}

@if (!errorLoadingProject && !ssrProjectLoad && project) {
  <div class="fx-layout-row fx-layout-column--xs fx-align--center-x
              fx-gap--4px fx-gap--0px--xs">
    @if (builderType !== 'SAMPLE') {
      <div class="left-col fx-flex">
        <!--
        <div class="builder-upsell" style="text-align: center">
          <span>
            ★
            We have <a (click)="customCornerInfo()">custom corner</a> &amp; <a (click)="vGrooveInfo()">v-groove</a>
            options!
            ★
          </span>
        </div>
        -->
        <div class="heading">
          @if (builderType === 'SAMPLE') {
            <h1>Product Samples</h1>
          }
          @if (project.builderHeading) {
            <h1 [innerHTML]="project.builderHeading"> </h1>
          }
          @if (builderSubHeading) {
            <h2 [innerHTML]="builderSubHeading"> </h2>
          }
        </div>
        @if (project) {
          <mbnm-carousel class="builder-preview-carousel" [ngClass]="{visible: project?.canPreview}"
            #mobileCarouselComponent>
            <mat-tab-group mbnmAddClass="carousel-selector" mbnmAddClassSelector="mat-tab-header" disableRipple="true"
              [ngClass]="{'hide-tabs': !project.moulding && !project.backingBoard && !project.glazing && !project.bag}"
              [(selectedIndex)]="selectedCarouselTab">
              <mat-tab>
                <ng-template mat-tab-label>
                  @if (projectThumbs && project && (project.moulding || project.backingBoard || project.glazing || project.bag)) {
                    <img alt="Custom Matboard Preview" [src]="projectThumbs.preview">
                  }
                </ng-template>
                <mbnm-project-preview #preview [project]="project" (editRequested)="projectEditRequested($event)">
                </mbnm-project-preview>
              </mat-tab>
              @if (project.moulding) {
                @for (view of ['profile','corner','front','back','hanger','spec']; track view) {
                  <mat-tab>
                    <ng-template mat-tab-label>
                      @if (view !== 'hanger') {
                        <img
                          [alt]="'moulding ' + view + ' preview'"
                          [src]="'/assets/images/products/frames/' + project.moulding.code + '/' + view + '-thumb.jpg'" />
                      }
                      @if (view === 'hanger') {
                        <img
                          [alt]="project.frameHangerType + 'hanger'"
                          [src]="'/assets/images/products/hangers/' + project.frameHangerType + '-thumb.jpg'" />
                      }
                    </ng-template>
                    @if (view !== 'hanger') {
                      <mbnm-basic-merch [title]="partDisplay.description(project.moulding) + ' - ' + viewDescriptions[view]" (backPressed)="selectedCarouselTab=0"
                        [imageUrl]="'/assets/images/products/frames/' + project.moulding.code + '/' + view + '-screen.jpg'"
                        [enlargedImageUrl]="'/assets/images/products/frames/' + project.moulding.code + '/' + view + '-large.jpg'">
                      </mbnm-basic-merch>
                    }
                    @if (view === 'hanger') {
                      <mbnm-basic-merch title="Frame Hanger Type" (backPressed)="selectedCarouselTab=0"
                        [imageUrl]="'/assets/images/products/hangers/' + project.frameHangerType + '-screen.jpg'"
                        [enlargedImageUrl]="'/assets/images/products/hangers/' + project.frameHangerType + '-large.jpg'">
                      </mbnm-basic-merch>
                    }
                  </mat-tab>
                }
              }
              @if (project.backingBoard) {
                <mat-tab>
                  <ng-template mat-tab-label>
                    @if (projectThumbs && projectThumbs.backing) {
                      <img alt="Backing board" [src]="projectThumbs.backing">
                    }
                  </ng-template>
                  <mbnm-basic-merch [project]="project" projectPropertyName="backingBoard" (backPressed)="selectedCarouselTab=0"></mbnm-basic-merch>
                </mat-tab>
              }
              @if (project.glazing) {
                <mat-tab>
                  <ng-template mat-tab-label>
                    @if (projectThumbs && projectThumbs.glazing) {
                      <img alt="Plexiglass glazing" [src]="projectThumbs.glazing">
                    }
                  </ng-template>
                  <mbnm-basic-merch [project]="project" projectPropertyName="glazing" (backPressed)="selectedCarouselTab=0"></mbnm-basic-merch>
                </mat-tab>
              }
              @if (project.bag) {
                <mat-tab>
                  <ng-template mat-tab-label>
                    @if (projectThumbs && projectThumbs.bag) {
                      <img alt="Show bags" [src]="projectThumbs.bag">
                    }
                  </ng-template>
                  <mbnm-basic-merch [project]="project" projectPropertyName="bag" (backPressed)="selectedCarouselTab=0"></mbnm-basic-merch>
                </mat-tab>
              }
            </mat-tab-group>
          </mbnm-carousel>
        }
      </div>
    }
    <div class="right-col"
      [ngClass]="{'is-sample': builderType == 'SAMPLE'}">
      <mbnm-price-and-buy class="fx-layout-row fx-align--space-between-x fx-align--x-center fx-gap--16px"
        [project]="project"
        (cancelEditClicked)="cancelEdit()"
        (addToCartClicked)="addToCartClicked($event)">
      </mbnm-price-and-buy>
      <!--
      [ngStyle.xs]="{'padding-bottom': project?.canBuy ? '111px' : '10px'}">
      -->
      <!-- TILES -->
      @for (productCategory of tileData; track productCategory; let idx = $index) {
        @if (productCategory.mainHeading) {
          <div class="fx-layout-row fx-align--space-between-x fx-align--x-center">
            <div>
              @if (productCategory.mainHeading) {
                <h3 class="group-title">
                  {{ productCategory.mainHeading }}
                </h3>
              }
              @if (productCategory.subHeading) {
                <div class="sub-heading" [innerHtml]="productCategory.subHeading">
                </div>
              }
            </div>
            <div>
              @if (idx == 0 && !project?.design) {
                <button class="clear-all" color="secondary" mat-flat-button="" (click)="clearAll($event)">
                  Clear All
                </button>
              }
            </div>
          </div>
        }
        @if (productCategory?.title) {
          <mbnm-builder-tile #tile (click)="openSelectorDialog(productCategory)"
            [title]="productCategory?.title" [ngClass]="{'can-buy': project?.canBuy}"
            [leftAlign]="true" [helpInfo]="productCategory.helpInfo"
            [disabled]="(productCategory.filteredProducts && productCategory.filteredProducts.length == 0) || missingDependencies(productCategory) >= 0"
            [openIcon]="determineTileIcon(productCategory)">
            <!-- REGULAR PRODUCT DESCRIPTION -->
            @if (productCategory.selection.length > 0 && project.numSamples == 0) {
              <div class="description"
                [hidden]="tile.selected">
                <a class="remove" [hidden]="project.permanentDesignId && productCategory.type === 'MAT'" (click)="removeProductSelection($event, productCategory);"><mat-icon svgIcon="x"></mat-icon></a>
                @if (productCategory.selection[0]) {
                  <span>
                    {{ productCategory.type == 'FRAME' ? partDisplay.longDescription(productCategory.selection[0]) : partDisplay.description(productCategory.selection[0]) }}
                    @if (productCategory.type == 'FRAME' && project.frameHangerType === 'wire') {
                      /w Wire Hanging Kit
                    }
                    @if (productCategory.type == 'FRAME' && project.frameHangerType === 'sawtooth') {
                      /w Sawtooth Hanger
                    }
                    @if (productCategory.type == 'SHOWBAG') {
                      {{ partDisplay.longDescription(productCategory.selection[0]) }}
                    }
                    @if (productCategory.type == 'MAT') {
                      {{partDisplay.code(productCategory.selection[0], '(#_)')}}
                      @if (productCategory.projectProperty == 'bottomMat') {
                        with {{ project.reveal | size:'multichar' | inches }} Reveal
                      }
                    }
                  </span>
                }
              </div>
            }
            @if (productCategory.type == 'MAT' && productCategory.projectProperty == 'topMat' && project.vGrooveOffset > 0) {
              <div class="description" style="display: block">
                <a class="remove" [hidden]="project.permanentDesignId && productCategory.type === 'MAT'" (click)="removeVGroove($event);">
                  <mat-icon svgIcon="x"></mat-icon>
                </a>
                <span>
                  {{ project.vGrooveOffset | size:'multichar' | inches }} Offset V-Groove
                </span>
              </div>
            }
            <!-- REGULAR PRODUCT DESCRIPTION UPSELL -->
            @if (productCategory.selection.length == 0) {
              <div class="description upsell">
                @if (this.determineCategoryState(productCategory) === 'required' && productCategory.isRequiredText !== null) {
                  <span>
                    {{ productCategory.isRequiredText }}
                  </span>
                }
                @if (this.determineCategoryState(productCategory) !== 'required'  && productCategory.upsellText !== null) {
                  <span>
                    {{ productCategory.upsellText }}
                  </span>
                }
              </div>
            }
            <!-- SIZES DESCRIPTION -->
            @if (productCategory.type == 'SIZE-SELECTOR' && !project.size.incomplete) {
              <div class="description bg">
                <span>
                  <i>{{ project.size.toString() }}</i> {{ builderType == 'MAT' || project.numMats > 0 ? 'Outer Size' : '' }}
                  @if (!project.design || project.numOpenings > 0) {
                    @for (opening of project.openings; track opening.size; let idx = $index) {
                      @if (!opening.size.incomplete) {
                        <div>
                          <i>{{ opening.size.toString() }}</i>
                          @if (opening.shape && opening.shape[0]) {
                            <i> {{ opening.shape[0].description }}</i>
                            } Opening
                            @if (opening.left && opening.top) {
                              <i>
                                at ({{ opening.left | size | inches }},{{ opening.top | size | inches }})
                              </i>
                            }
                            @if (opening.reveal && opening.reveal > 0) {
                              <span>
                                with {{ opening.reveal | size | inches }} reveal
                              </span>
                            }
                          </div>
                        }
                      }
                    }
                    @if (project.design && project.numOpenings === 0) {
                      <div>
                        <br />
                        Custom Opening(s)
                      </div>
                    }
                    @if (project.numMats > 1 && !project.permanentDesignId) {
                      <br />
                      <i>{{ project.reveal | size:'multichar' | inches }}</i> Reveal
                    }
                    @if (project.centeredMargins.height !== project.bottomMargin && project.numOpenings > 0 && !project.opening.size.incomplete) {
                      <br />
                      <i>{{ project.bottomMargin | size:'multichar' | inches }}</i> Bottom Margin
                      @if (project.bottomMargin == project.topCenterBottomMargin) {
                        <i>
                          (Top Centered)
                        </i>
                      }
                    }
                    <!-- Include details of the design v-groove -->
                    @for (vgroove of project.vgrooves; track vgroove.size) {
                      <br />
                      <i>{{ vgroove.size.width | size | inches }} x {{ vgroove.size.height | size | inches }}</i>
                      @if (vgroove.shape && vgroove.shape[0]) {
                        <i> {{ vgroove.shape[0].description }}</i>
                        } V-Groove
                        @if (vgroove.left && vgroove.top) {
                          <i>
                            at ({{ vgroove.left | size | inches }},{{ vgroove.top | size | inches }})
                          </i>
                        }
                      }
                    </span>
                  </div>
                }
                <!-- NOT AVAILABLE -->
                @if ((productCategory.selection.length == 0 && productCategory.filteredProducts) || missingDependencies(productCategory) >= 0) {
                  <div class="description">
                    @if (productCategory.filteredProducts && productCategory.filteredProducts.length == 0) {
                      <span>None Available</span>
                    }
                    @if (missingDependencies(productCategory) >= 0) {
                      <span [innerHtml]="productCategory.missingDependencyMessage[missingDependencies(productCategory)]"></span>
                    }
                  </div>
                }
                <!-- SAMPLES DESCRIPTION -->
                @for (sample of getProjectSamples(productCategory.type); track sample; let sampleIndex = $index) {
                  @if (productCategory.type == 'MAT' && sample.categoryName && isSampleCategoryStart(getProjectSamples(productCategory.type), sampleIndex)) {
                    <div class="sample-category">{{ sample.categoryName }}</div>
                  }
                  <div class="description samples">
                    <a class="remove" (click)="removeSample($event, sample);"><mat-icon svgIcon="x"></mat-icon></a>
                    <span>
                      {{ productCategory.type == 'FRAME' ? partDisplay.longDescription(sample) : partDisplay.description(sample) }}
                      @if (productCategory.type == 'SHOWBAG') {
                        {{ partDisplay.longDescription(sample) }}
                      }
                      @if (productCategory.type == 'MAT') {
                        {{partDisplay.code(sample, '(#_)')}}
                      }
                    </span><br />
                  </div>
                }
              </mbnm-builder-tile>
            }
          }
          @if (project && builderType !== 'SAMPLE') {
            <h3 class="group-title">
              Artwork <i>(Preview Only)</i>
            </h3>
            <div class="artwork">
              <div class="description">
                @if (project?.hasPrint) {
                  <span>
                    The artwork presented is for preview purposes only.
                    <strong>No print will be provided.</strong>
                    Click <a (click)="removePrint()">here to remove</a> your artwork.
                  </span>
                }
                @if (!project?.hasPrint) {
                  <span>
                    Upload an image of your artwork to help visualize the final product.  This step is optional. <strong>No print will be provided.</strong>
                  </span>
                }
                <mbnm-uploader [disclaimerAccepted]="project.hasPrint" acceptedFileTypes="image/*"
                  (uploadComplete)="printUploadCompleted($event)"
                  uploadPath="/print/"
                  (uploadFailed)="printUploadFailed($event)">
                  <mat-icon svgIcon="image-upload"></mat-icon>
                </mbnm-uploader>
              </div>
            </div>
          }
          @if ((builderType === 'MAT' || builderType === 'FRAME') && project?.allowCustomization) {
            @if (project?.allowCustomization) {
              <h3 class="group-title line-above">
                Upload Design File
              </h3>
            }
            <div class="artwork">
              <div class="description">
                <span>
                  Upload design (GMC/WZX) files.  Uploading more than once will replace
                  previously uploaded files.
                </span>
                <mbnm-uploader [disclaimerAccepted]="true" acceptedFileTypes=".gmc,.wzx,.wcx" [allowMultiple]="true"
                  uploadPath="/design/"
                  (uploadComplete)="designUploaded($event)"
                  (uploadFailed)="designUploadFailed($event)">
                  <mat-icon svgIcon="upload"></mat-icon>
                </mbnm-uploader>
              </div>
            </div>
            <div class="design-upload-notifications">
              <mat-form-field>
                <mat-label>complexity upcharge</mat-label>
                <input matInput
                  type="number"
                  [(ngModel)]="project.complexityUpCharge">
                </mat-form-field>
                <br />
                <mat-form-field>
                  <mat-label>special instructions</mat-label>
                  <textarea matInput rows="5"
                    [(ngModel)]="project.instructions">
                  </textarea>
                </mat-form-field>
              </div>
            }
            @if (project && this.builderType !== 'SAMPLE') {
              <div
                class="share-container fx-layout-row fx-layout-wrap fx-gap--8px fx-align--space-between-x">
                @for (shareType of shareTypes; track shareType) {
                  <div class="fx-layout-column fx-flex--100--lt-md"
                    [ngClass]="{'fx-flex--100': shareType.name === 'help', 'fx-flex--45--gt-sm': shareType.name !== 'help'}">
                    <button mat-flat-button (click)="startShare(shareType)" [color]="shareType.buttonColor"
                      [matMenuTriggerFor]="showShareMenu(shareType) ? menu : null" [matTooltip]="shareType.toolTip">
                      <span class="wrapper">
                        {{ shareType.text }}
                        <mat-icon [svgIcon]="shareType.icon"> </mat-icon>
                      </span>
                    </button>
                    @if (shareType.active && gettingProjectId) {
                      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    }
                  </div>
                  <mat-menu #menu="matMenu">
                    @for (platform of sharePlatforms; track platform.name) {
                      <button mat-menu-item
                        [shareButton]="platform.name" [url]="platform.link ? platform.link() : activeShareType?.link()"
                        [hidden]="activeShareType?.excludePlatforms?.includes(platform.name)">
                        <mat-icon [svgIcon]="platform.icon" [ngStyle]="{'color': platform.iconColor}"> </mat-icon>
                        {{ platform.description }}
                      </button>
                    }
                  </mat-menu>
                }
              </div>
            }
          </div>
        </div>
        @if (currentCart && currentCart.promotion) {
          <mbnm-promotion [shoppingCart]="currentCart"></mbnm-promotion>
        }
        <mbnm-reviews [reviewCount]="6" starRating="5" filterBy="has_images" title="See what other customers are saying about us..."></mbnm-reviews>
      }
